import { isNil } from 'lodash';

export const toInt = (value, radix = 10) => parseInt(value, radix);

export const toString = (value, defaultValue = '') => {
  if (isNil(value) || value === Number.POSITIVE_INFINITY) return defaultValue;

  return value.toString();
};
